import React from 'react';
import { graphql } from "gatsby";
import { makeStyles } from '@material-ui/styles';
import {buildBlocks} from "../../../services/builder";
import styles from './styles';

const useStyles = makeStyles(theme => styles(theme));

export const BblImageContentRowsBlock = (props) => {

    const blocks = buildBlocks(props.innerBlocks, props.parentAttributes, props.pageContext);
    const classes = useStyles();

    return <div className={`${props.attributes.className ? props.attributes.className : ''} ${classes.imageContentRows}`}
                data-override-starting-side={ props.attributes.isEven ? 'even' : null }
    >
        {blocks.map((block) => {
            return block;
        })}
    </div>
};

export const BblImageContentRowsBlockFragment = graphql`
  fragment BblImageContentRowsBlock on WpBlock {
    ... on WpBblImageContentRowsBlock {
        name
        attributes {
            className
            isEven
        }
      }
  }`;

// This is the string version of this that is used within previews and without WP prefixes
export const BblImageContentRowsBlockPreview = `
    ... on BblImageContentRowsBlock {
        name
        attributes {
            className
            isEven
        }
    }
`;